import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { lyfshortLogin, logout } from "../slices/auth/authSlice";
import { fetchAccessTokenSuccess } from "../slices/accessToken/accessTokenSlice";

// Define a proper type for the payload
interface AuthStatePayload {
  authData: {
    authId: string | null;
    tokens: {
      accessToken: string | null;
    } | null
  };
  signupData: object | null;
}

// Listen for authentication state changes (Firebase session persistence)
export const firebaseAuthStateChanged = createAsyncThunk<void, AuthStatePayload>(
  'auth/firebaseAuthStateChanges',
  async ({ authData, signupData }: AuthStatePayload, { dispatch, getState }) => {
    const state: RootState = (getState() as RootState);
    if (authData.authId !== null) {
      if (state.auth.isLyfshortLoggedIn) {
        if (authData.authId !== state.accessToken.authId) {
          dispatch(logout());
          dispatch(lyfshortLogin({
            authData,
            signupData
          }))
        } else {
          dispatch(fetchAccessTokenSuccess({
            authId: authData.authId,
            tokens: authData.tokens
          }))
        }
      } else {
        if (!state.auth.updating) {
          dispatch(lyfshortLogin({
            authData,
            signupData
          }))
        }
      }
    } else {
      if (state.auth.isLyfshortLoggedIn) {
        dispatch(logout());
      }
    }
  }
)
